import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Building } from '../../../../../api/types/settings/buildings/building';

interface BuildingListDialogProps {
  visible: boolean;
  onHide: () => void;
  buildings: Building[];
  selectedBuildings: Building;
  onSelectionChange: (buildings: Building) => void;
  onConfirm: () => void;
}

export const BuildingListDialog: React.FC<BuildingListDialogProps> = ({
  visible,
  onHide,
  buildings,
  selectedBuildings,
  onSelectionChange,
  onConfirm,
}) => {
  const [globalFilter, setGlobalFilter] = useState('');

  const header = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <h3 style={{ margin: 0 }}>רשימת מבנים</h3>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          value={globalFilter}
          onChange={(e) => setGlobalFilter(e.target.value)}
          placeholder="חיפוש..."
          style={{ width: '200px' }}
        />
      </span>
    </div>
  );

  return (
    <Dialog
      header="בחירת מבנים"
      visible={visible}
      onHide={onHide}
      style={{
        width: '800px',
        backgroundColor: 'white',
        borderRadius: '8px',
      }}
      footer={
        <div
          style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}
        >
          <Button
            label="ביטול"
            icon="pi pi-times"
            onClick={onHide}
            className="p-button-text"
          />
          <Button
            label="אישור"
            icon="pi pi-check"
            onClick={onConfirm}
            disabled={selectedBuildings.length === 0}
          />
        </div>
      }
    >
      <div style={{ padding: '16px 0' }}>
        <DataTable
          value={buildings}
          selection={selectedBuildings}
          onSelectionChange={(e) => onSelectionChange(e.value)}
          dataKey="id"
          header={header}
          globalFilter={globalFilter}
          emptyMessage="לא נמצאו מבנים"
          selectionMode="multiple"
          style={{ width: '100%' }}
          scrollHeight="400px"
          scrollable
          className="p-datatable-striped"
        >
          <Column selectionMode="single" style={{ width: '3rem' }} />
          <Column
            field="buildingName"
            header="שם המבנה"
            sortable
            style={{ textAlign: 'right' }}
          />
          <Column
            field="address"
            header="כתובת"
            sortable
            style={{ textAlign: 'right' }}
          />
        </DataTable>
      </div>
    </Dialog>
  );
};
